import * as yup from 'yup'

export default yup.object().shape({
  spe_id: yup.string().required('O campo SPE é requerido.'),
  uau_vendedor_code: yup.string().nullable()
})
